import {HistoryRecordBaseModel} from "./history-record-base.model";
import {JackpotBetsGamingHistoryRecordRawData} from "../../gaming-history.service.interfce";
import {
    IHistoryRecordAmountViewModel,
    IHistoryRecordIdViewModel
} from "./history-record-view-model.interface";
import {CyClass} from "../../../../../common/cy-classes";

export class JackpotBetsGamingHistoryRecordModel extends HistoryRecordBaseModel<JackpotBetsGamingHistoryRecordRawData> {
    get amounts(): IHistoryRecordAmountViewModel[] {
        return [
            {
                description: this.translation.translate('GAMING_HISTORY_BET'), //! TODO
                value: this._formatValue(this.recordData.BetAmount),
                cyClass: CyClass('cy-jackpot-bets-gaming-history-bet-amount')
            },
            {
                description: this.translation.translate('GAMING_HISTORY_WINNINGS'),
                value: this._formatValue(this.recordData.TotalWins),
                cyClass: CyClass('cy-jackpot-bets-gaming-history-winning-value')
            },
            // {
            //     description: this.translation.translate('HISTORY_GAME_SESSION_BALANCE'),
            //     value: this._formatValue(this.recordData.),
            //     cyClass: CyClass('cy-gaming-history-bankroll-value')
            // }
        ];
    }

    get bigWinMessage(): string | null {
        return null;
    }

    get date(): string {
        return this.services.time.formatHistoryRecordDateTime(this.recordData.Date,  false);
    }

    get freePlayMessage(): string | null {
        return null;
    }

    get ids(): IHistoryRecordIdViewModel[] {
        return [
            {
                text: this.recordData.GameId,
                cyClass: CyClass('cy-jackpot-bets-gaming-history-game-id')
            }
        ];
    }

    protected _isDetailHistorySupported(): boolean {
        return false;
    }

    get detailsHistoryNotAllowedOnCurrentPlatformMessage(): string | null {
        return null;
    }

    async openDetailHistory(): Promise<void> {
        // for session history details history is not allowed so nothing to do there
    }
}